/** @format */

import Cookies from "./../library/Cookies";

export default class CookiesPopup {
    constructor() {
        this.instance = self;
    }

    static init() {
        const self = new CookiesPopup();
        self.attachEvents();
    }

    attachEvents() {
        const self = this;

        console.log("=== Cookie Debugging ===");
        console.log("Server says cookie exists:", window.cookieExists);

        // Use server-side detection instead of client-side cookie reading
        if (!window.cookieExists) {
            console.log("Opening cookies bar - server says no cookie exists");
            self.openCookiesBar();
        } else {
            console.log(
                "Not opening cookies bar - server detected existing cookie",
            );
        }

        window.site.closeCookiesPopup = function () {
            self.closeCookiesPopup();
        };

        window.site.closeCookiesBar = function () {
            self.closeCookiesBar();
        };

        $(document).on("click", ".js-cookie-popup", function (e) {
            e.preventDefault();

            // This will trigger performance all checkboxes
            window.site.openCookiePopup($(this).attr("href"));
        });

        $(document).on("click", ".js-cookies-accept-all", function (e) {
            e.preventDefault();
            self.acceptAllCookies();
        });

        $(document).on("click", ".js-cookies-reject-all", function (e) {
            e.preventDefault();
            self.rejectAllCookies();
        });

        $(document).on("click", ".js-manage-cookies", function (e) {
            e.preventDefault();
            self.closeCookiesBar(); // close - user to now use popup
        });

        $(document).on("click", ".js-toggle-cookies-accordion", function (e) {
            e.preventDefault();
            self.toggleAccordion($(this));
        });

        // Showing more
        $(document).on("click", ".js-toggle-cookies-show-more", function (e) {
            e.preventDefault();
            self.toggleShowMore($(this));
        });

        $(document).on(
            "click",
            ".js-toggle-child-cookies-show-options",
            function (e) {
                e.preventDefault();
                self.toggleSubCookies($(this));
            },
        );
        // End showing more

        // Checking checkboxes
        $(document).on(
            "change",
            ".js-toggle-all-accordion-section-checkboxes",
            function () {
                self.toggleAllAccordionSectionCheckboxes($(this));
            },
        );

        $(document).on(
            "change",
            ".js-toggle-all-child-cookies-checkboxes",
            function () {
                self.toggleAllChildCookiesCheckboxes($(this));
            },
        );

        $(document).on(
            "change",
            ".cookies-popup-accordion-content input",
            function () {
                // console.log("Child cookie change!");

                const $checkbox = $(this);
                const $masterCheckbox = $(this)
                    .closest(".cookies-popup-accordion-section")
                    .find(".js-cookie-master-switch");

                // If this checkbox is not checked - master switch should be unchecked!
                if (!$checkbox.is(":checked")) {
                    $masterCheckbox.prop("checked", false);
                }

                const $parentCookieSection = $checkbox.closest(
                    ".cookies-popup-accordion-content",
                );
                self.toggleMasterCheckox($parentCookieSection, $masterCheckbox);
            },
        );
        // End Checking checkboxes

        $(document).on("submit", ".js-cookies-popup-form", (e) => {
            const formData = $(e.currentTarget).serializeArray();
            const privacySettings = this.processFormData(formData);
            this.setPrivacyCookie(privacySettings);
        });
    }

    processFormData(formData) {
        const settings = {
            essential_all: 1,
            performance_all: 0,
            essential: {},
            performance: {},
        };

        // Initialize with default values from config if available
        if (window.cookiesConfig) {
            if (window.cookiesConfig.essential) {
                Object.keys(window.cookiesConfig.essential).forEach((id) => {
                    settings.essential[id] = 1;
                });
            }
        }

        formData.forEach((item) => {
            const nameMatch = item.name.match(
                /cookiesPopup\[(.*?)\](?:\[(.*?)\])?/,
            );
            if (nameMatch) {
                const group = nameMatch[1];
                const id = nameMatch[2];

                if (id) {
                    settings[group][id] = parseInt(item.value);
                } else {
                    settings[group] = parseInt(item.value);
                }
            }
        });

        return settings;
    }

    setPrivacyCookie(data) {
        console.log("Setting privacy cookie via JS:", data);
        const cookieVal = JSON.stringify(data);
        // Set for 90 days (7776000 seconds / 60 / 60 / 24 = 90 days)
        Cookies.setCookie("privacy_settings", cookieVal, 90);
        window.cookieExists = true;
    }

    closeCookiesPopup() {
        const self = this;

        if ($.magnificPopup.instance) {
            $.magnificPopup.instance.close();
        }

        return self;
    }

    openCookiesBar() {
        const self = this;

        $("body").addClass("cookies-open");

        $(".cookies-bar-bg").fadeIn();
        $(".cookies-bar").slideDown(200);

        return self;
    }

    closeCookiesBar() {
        const self = this;

        $(".cookies-bar").slideUp(200);
        $(".cookies-bar-bg").fadeOut();

        $("body").removeClass("cookies-open");

        self.removeCookieElemsFromDom();

        return self;
    }

    removeCookieElemsFromDom() {
        const self = this;

        $(".cookies-bar").remove();
        $(".cookies-bar-bg").remove();

        // Send a page view event on cookies bar close - otherwise won't get sent to GA4 until they load the page again, won't get sent through if consent is denied
        // send_to is required for correct tracking after consent update? Also slight delay added to allow for consent to update and user engagement registered
        setTimeout(() => {
            gtag("event", "page_view", {
                send_to: "G-HJD31F1MMT",
                page_title: document.title,
                page_location: window.location.href,
            });
        }, 500);

        return self;
    }

    toggleAccordion($link) {
        const self = this;

        let $accordion = $link.parents(".cookies-popup-accordion"),
            $content = $link
                .parents(".cookies-popup-accordion-section-title")
                .next(".cookies-popup-accordion-content");

        if ($content.is(":hidden")) {
            $content.slideDown(200);
            $link.text("Hide details");
        } else {
            $content.slideUp(200);
            $link.text("Show details");
        }
    }

    toggleShowMore($link) {
        const self = this;

        let $content = $link.next(".cookies-popup-content-more-content");

        if ($content.is(":hidden")) {
            $content.slideDown(200);
            $link.text("Hide more details");
        } else {
            $content.slideUp(200);
            $link.text("Show more details");
        }
    }

    toggleSubCookies($link) {
        const self = this;

        const $content = $link.next(".cookies-popup-child-cookies-options");

        if ($content.is(":hidden")) {
            $content.slideDown(200);
            $link.text("Hide individual cookie options");
        } else {
            $content.slideUp(200);
            $link.text("Show individual cookie options");
        }
    }

    // Checking checkboxes
    toggleMasterCheckox($section, $masterCheckbox) {
        const self = this;

        let allChecked = true; // Assume all checkboxes are checked initially

        const sectionInputs = $section.find("input");

        $.each(sectionInputs, function () {
            if (!$(this).is(":checked")) {
                // console.log("Not all checkboxes are checked");
                allChecked = false; // Set the flag to false if an unchecked checkbox is found
                return false; // This will stop the loop
            }
        });

        if (allChecked) {
            // console.log("All checkboxes are checked");
            $masterCheckbox.prop("checked", true); // Check the master checkbox if all checkboxes are checked
        } else {
            $masterCheckbox.prop("checked", false); // Uncheck the master checkbox if not all checkboxes are checked
        }

        return self;
    }

    toggleAllAccordionSectionCheckboxes($checkbox) {
        const self = this,
            $section = $checkbox.parents(".cookies-popup-accordion-section"),
            $checkboxes = $section.find('input[type="checkbox"]');

        if ($checkbox.is(":checked")) {
            $checkboxes.prop("checked", true);
        } else {
            $checkboxes.prop("checked", false);
        }
    }

    toggleAllChildCookiesCheckboxes($checkbox) {
        const self = this,
            $section = $checkbox.closest(
                ".cookies-popup-accordion-content-section-has-child-cookies",
            ),
            $checkboxes = $section.find('input[type="checkbox"]');

        if ($checkbox.is(":checked")) {
            $checkboxes.prop("checked", true);
        } else {
            $checkboxes.prop("checked", false);
        }
    }
    // End checking checkboxes

    acceptAllCookies() {
        const self = this;

        const settings = {
            essential_all: 1,
            performance_all: 1,
            essential: {},
            performance: {},
        };

        if (window.cookiesConfig) {
            if (window.cookiesConfig.essential) {
                Object.keys(window.cookiesConfig.essential).forEach((id) => {
                    settings.essential[id] = 1;
                });
            }
            if (window.cookiesConfig.performance) {
                Object.keys(window.cookiesConfig.performance).forEach((id) => {
                    settings.performance[id] = 1;
                });
            }
        }

        self.setPrivacyCookie(settings);

        // Works when using popup - not when using the bar now since it needs ajax
        if ($(".js-toggle-all-accordion-section-checkboxes").length) {
            $(".js-toggle-all-accordion-section-checkboxes").each(function () {
                $(this).prop("checked", true);
                self.toggleAllAccordionSectionCheckboxes($(this));
            });
        }

        oc.ajax("cookiesPopup::onSaveCookies", {
            data: {
                performance_all: 1,
                essential_all: 1,
            },
            update: {
                "site/tracking-update": ".js-site-tracking",
            },
        })
            .then(() => {
                self.closeCookiesPopup().closeCookiesBar();
            })
            .finally(() => {
                oc.progressBar.hide();
            });

        return self;
    }

    rejectAllCookies() {
        const self = this;

        const settings = {
            essential_all: 1,
            performance_all: 0,
            essential: {},
            performance: {},
        };

        if (window.cookiesConfig) {
            if (window.cookiesConfig.essential) {
                Object.keys(window.cookiesConfig.essential).forEach((id) => {
                    settings.essential[id] = 1;
                });
            }
        }

        self.setPrivacyCookie(settings);

        oc.ajax("cookiesPopup::onSaveCookies", {
            data: {
                essential_all: 1,
                performance_all: 0,
            },
            update: {
                "site/tracking-update": ".js-site-tracking",
            },
        })
            .then(() => {
                self.closeCookiesPopup().closeCookiesBar();
            })
            .finally(() => {
                oc.progressBar.hide();
            });

        return self;
    }
}
